import { TABNAME_MAX_LENGTH } from '@/config/name';
import { useAppForm } from '@/features/dashboard/components/AppForm/AppForm/context';
import { DashboardNameInput } from '@/features/dashboard/components/DashboardNameInput';

export const TabName = () => {
  const { form, setCanPreview } = useAppForm();
  return (
    <section className='flex flex-col rounded-xl bg-card p-4 pb-6'>
      <h3 className='mb-2 text-sm font-semibold'>Tab title</h3>
      <p className='mb-4 text-xs font-medium text-muted-foreground'>
        Give your tab a meaningful name
      </p>
      <form.Field
        children={field => (
          <DashboardNameInput
            error={form.state.errorMap.onChange?.name}
            maxLength={TABNAME_MAX_LENGTH}
            value={field.state.value}
            onBlur={() => {
              setCanPreview(true);
            }}
            onChange={field.handleChange}
            onFocus={() => {
              setCanPreview(false);
            }}
          />
        )}
        name='name'
      />
    </section>
  );
};
